// lib/workspace-scope.ts
import type { RefObject } from 'react';
import type { KernelHandle } from '#types/types';

export const requireWorkspaceProjectIdFromKernel = (
  kernelRef: RefObject<KernelHandle | null>,
  workspaceIdInput: string | null | undefined,
  context: string
): string => {
  const kernel = kernelRef.current;
  if (!kernel) {
    throw new Error(`[${context}] Kernel not available.`);
  }
  const workspaceId = typeof workspaceIdInput === 'string' ? workspaceIdInput.trim() : '';
  if (!workspaceId) {
    throw new Error(`[${context}] workspaceId is required.`);
  }
  const workspace = kernel.getInventory().StudioWorkspace.registry[workspaceId];
  const projectId = typeof workspace?.projectId === 'string' ? workspace.projectId.trim() : '';
  if (!projectId) {
    throw new Error(`[${context}] Missing explicit project scope for workspace "${workspaceId}".`);
  }
  return projectId;
};
